var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CartButtonIcon'),_c('span',{staticClass:"button-text"},[_vm._v(" Continuar ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }